module.exports = __webpack_public_path__ + "img/142-Beige Croe Stylo.jpg";